import React, { useState, useEffect, useRef } from 'react';
import styles from './Typewriter.module.css';

const PHRASES = [
  'Where Legends Are Born, and Communities Thrive',
  'Join the Siege. Claim Your Castle.',
  'Forge Your Legacy in the World of Aden.',
  'Zero Pay-to-Win. Pure Skill. Real Glory.',
  'Your Clan Awaits. The Adventure Begins.',
];

const TYPING_SPEED = 52;
const DELETE_SPEED = 28;
const PAUSE_AFTER = 2200;
const PAUSE_BEFORE = 400;

export default function Typewriter() {
  const [display, setDisplay] = useState('');
  const [phase, setPhase] = useState('typing');
  const [phraseIdx, setPhraseIdx] = useState(0);
  const [charIdx, setCharIdx] = useState(0);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const current = PHRASES[phraseIdx];

    if (phase === 'typing') {
      if (charIdx < current.length) {
        timeoutRef.current = setTimeout(() => {
          setDisplay(current.slice(0, charIdx + 1));
          setCharIdx(i => i + 1);
        }, TYPING_SPEED);
      } else {
        timeoutRef.current = setTimeout(() => setPhase('deleting'), PAUSE_AFTER);
      }
    } else if (phase === 'deleting') {
      if (charIdx > 0) {
        timeoutRef.current = setTimeout(() => {
          setDisplay(current.slice(0, charIdx - 1));
          setCharIdx(i => i - 1);
        }, DELETE_SPEED);
      } else {
        timeoutRef.current = setTimeout(() => {
          setPhraseIdx(i => (i + 1) % PHRASES.length);
          setPhase('typing');
        }, PAUSE_BEFORE);
      }
    }

    return () => clearTimeout(timeoutRef.current);
  }, [phase, charIdx, phraseIdx]);

  return (
    <span className={styles.typewriter} aria-label={PHRASES[phraseIdx]}>
      {display}
      <span className={styles.cursor} aria-hidden="true">|</span>
    </span>
  );
}
